import { all, put, takeEvery } from 'redux-saga/effects';
import en from './languages/english';
import se from './languages/swedish';
import no from './languages/norwegian';
import da from './languages/danish';
import fi from './languages/finnish';
import ru from './languages/russian';
import sp from './languages/spanish';
import ch from './languages/chinese';
import bz from './languages/brazilian_portuguese';
import pl from './languages/polish';
import tk from './languages/turkish';
import nd from './languages/dutch';
import fr from './languages/french';
import gm from './languages/german';
import hd from './languages/hindi';
import it from './languages/italian';
import jp from './languages/japanese';
import kr from './languages/korean';


import { setLocalizationLangsSuccess } from './actions';

import { SET_LOCALIZATION_LANGS } from './constants';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{langs, type, content}>>}
 */
function* setLocalizationLangs( actionObj ) {

    switch ( actionObj.langs ) {
        case 'en': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, en ) );
            break;
        }
        case 'se': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, se ) );
            break;
        }
        case 'no': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, no ) );
            break;
        }
        case 'da': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, da ) );
            break;
        }
        case 'fi': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, fi ) );
            break;
        }
        case 'ru': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, ru ) );
            break;
        }
        case 'sp': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, sp ) );
            break;
        }
        case 'ch': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, ch ) );
            break;
        }
        case 'bz': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, bz ) );
            break;
        }

        case 'pl': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, pl ) );
            break;
        }
        case 'tk': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, tk ) );
            break;
        }
        case 'nd': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, nd ) );
            break;
        }
        case 'fr': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, fr ) );
            break;
        }
        case 'gm': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, gm ) );
            break;
        }
        case 'hd': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, hd ) );
            break;
        }
        case 'it': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, it ) );
            break;
        }
        case 'jp': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, jp ) );
            break;
        }
        case 'kr': {
            yield put( setLocalizationLangsSuccess( actionObj.langs, kr ) );
            break;
        }
        default :
            yield put( setLocalizationLangsSuccess( actionObj.langs, en ) );
    }
}

function* watchSetLocalizationLangs() {
    yield takeEvery( SET_LOCALIZATION_LANGS, setLocalizationLangs );
}

function* localizationSaga() {
    yield all( [
        watchSetLocalizationLangs()
    ] );
}

export default localizationSaga;